"use client";
import * as React from "react";
import { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { faqData } from "../../dummydata/navBarData.js";
import { Grid, Typography } from "@mui/material";

interface FaqAccordianProps {
  seoContent: any;
}

const FaqAccordian: React.FC<FaqAccordianProps> = ({ seoContent }) => {
  const [expanded, setExpanded] = useState(Array(faqData.length).fill(false));

  const handleChange = (index: any) => () => {
    setExpanded((prevExpanded) => {
      const newExpanded = [...prevExpanded];
      newExpanded[index] = !newExpanded[index];
      return newExpanded;
    });
  };

  return (
    <Grid
      container
      item
      md={9.5}
      lg={9.5}
      sx={{
        margin: "5rem auto",
        width: "100%",
      }}
    >
      <Typography
        variant="h5"
        style={{
          paddingBottom: "2rem",
          color: "",
          textAlign: "center",
          width: "100%",
        }}
      >
        Frequently Asked Questions
      </Typography>
      <div style={{ width: "100%" }}>
        {seoContent?.seoContentItems?.map((item: any, index: number) => (
          //{faqData?.map((item, index) => (
          <>
            <Accordion
              // className="faq-accordian-card"
              key={index}
              expanded={expanded[index]}
              onChange={handleChange(index)}
              aria-controls={`item${index}-content`}
              id={`item${index}-header`}
              sx={{
                width: "100%",
                padding: "2px",
                // background: "#e5efe7",
                // background: "rgb(21, 116, 26)",
                // color: "white",
                // border: "none",
                // boxShadow: "none",
                "&::before": {
                  // display: "none",
                },
              }}
            >
              <AccordionSummary
                expandIcon={
                  expanded[index] ? (
                    <RemoveCircleIcon style={{ color: "rgb(21, 116, 26)" }} />
                  ) : (
                    <AddCircleIcon style={{ color: "rgb(21, 116, 26)" }} />
                  )
                }
                aria-controls={`item${index}-content`}
                id={`item${index}-header`}
              >
                <Typography variant="body2" sx={{ fontWeight: "" }}>
                  {item.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2" sx={{ color: "#858181c9" }}>
                  {item.content}
                </Typography>
                {/* chnage text to content */}
              </AccordionDetails>
            </Accordion>
            {/* <Divider /> */}
          </>
        ))}
      </div>
    </Grid>
  );
};

export default FaqAccordian;
